/*
 * -----------------------------------------------------------------------
 *  <copyright file="index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { useTranslation } from 'hooks';
import ExpandableGridV2 from 'views/components/core/expandable/grid-v2';
import './styles.scss';

const ImportErrorsV2 = ({ errors }: any) => {
    const { t } = useTranslation();
    return (
        <>
            <div className="secondary import-errors">{t('ra:importErrors', { count: errors.length })}</div>
            <ExpandableGridV2
                customKey="errors-grid"
                id="imported-errors"
                key="imported-errors-grid"
                items={errors}
                groupable={false}
                pageable={false}
                scrollable="scrollable"
                reorderable
                showPager
                resizable
                hideCheckbox
                hideExpand
                showFirstColumn={false}
                initialSort={false}
                columns={[
                    {
                        field: 'line',
                        label: t('ra:line'),
                        width: 120,
                    },
                    {
                        field: 'message',
                        label: t('ra:message'),
                        width: 620,
                    },
                ]}
            />
        </>
    );
};

export default ImportErrorsV2;
